module.exports = __webpack_public_path__ + "img/HC_HC-DIG.4d9fd313.png";